import * as Yup from 'yup';

export const INITIAL_VALUES = {
  wagered: 0,
};

export const FORM_VALIDATION_SCHEMA = Yup.object().shape({
  wagered: Yup.number().required('Wagered is required'),
});
